
import { mapPlayablesToEpisodes } from '~/utils'
import { metaDataMixin } from '~/mixins'

/**
 *  We also want to know in SSR what our default
 *  publication data might be in asyncData
 * */
const publicationData = {
  broadcastChannel: null,
  changedOn: null,
  environmentId: null,
  hero: null,
  heroVideo: null,
  heroVideoStill: null,
  id: null,
  intro: null,
  pomsId: null,
  publishOn: null,
  seo: null,
  slug: null,
  social: null,
  subtitle: null,
  title: null,
  type: null,

  topic: null,
  episodes: [],
}

export default {
  mixins: [
    metaDataMixin,
  ],
  layout: 'program',
  scrollToTop: false,
  async asyncData ({ $api, $config, error, params: { program: slug } }) {
    if (slug) {
      const [
        { data: { items: programs = [] } = {} },
      ] = await Promise.all([
        // Get program for this slug
        $api.programs.getOneBySlug(slug, {
          domain: $config.preprEnvironmentDomainGeneriek,
        }),
      ])

      // Check if we found a valid publication
      if (programs[0]?.id) {
        const program = programs[0]
        const publication = Object.keys(publicationData).reduce(
          (obj, key) => (
            { ...obj, [key]: program[key] }
          ),
          {},
        )

        // Fetch episodes from poms
        const { episodes: programEpisodes = [], pomsId, type } = program
        const episodes = []
        let hasMoreEpisodesAvailable = false

        if (pomsId && programEpisodes.length) {
          const { data: { items: episodeItems = [], meta } = {} } = await $api.poms.playables.getAll({
            descendantOf: pomsId,
            offset: 0,
            limit: type == 'Webserie' ? 53 : 6,
            type: type == 'Webserie' ? 'CLIP' : 'BROADCAST',
          })

          episodes.push(...mapPlayablesToEpisodes(episodeItems))
          hasMoreEpisodesAvailable = meta ? meta.total > episodes.length : true
        }

        return {
          ...publication,
          episodes,
          hasMoreEpisodesAvailable,
          seo: {
            ...program.seo,
            title: `Afleveringen van ${program.seo.title}'`,
          },
          social: {
            ...program.social,
            title: `Afleveringen van ${program.social.title}'`,
          },
        }
      } else {
        error({
          context: `Couldn't find program: ${slug}.`,
          message: '(404) Programma niet gevonden',
          severity: 'info',
          statusCode: 404,
        })

        return false
      }
    }
  },
  data () {
    return {
      ...publicationData,
      topicPrograms: [],
      hasMoreEpisodesAvailable: false,
    }
  },
  async fetch () {
    const tPrograms = await this.fetchTopicPrograms()
    this.topicPrograms = tPrograms
  },
  computed: {
    socialCookiesAllowed () {
      return this.$store.state.cookieConsent.social
    },
  },
  methods: {
    async loadMoreEpisodes () {
      const { data: { items: pEpisodes = [], meta } } = await this.$api.poms.playables.getAll({
        descendantOf: this.pomsId,
        offset: this.episodes.length,
        limit: this.type == 'Webserie' ? 53 : 6,
        type: this.type == 'Webserie' ? 'CLIP' : 'BROADCAST',
      })
      this.episodes.push(...mapPlayablesToEpisodes(pEpisodes))
      this.hasMoreEpisodesAvailable = meta.total > this.episodes.length
    },
    async fetchTopicPrograms (offet = 0, limit = 3) {
      if (!this.topic) return []

      const { data: { items: tPrograms = [] } = {} } = await this.$api.topics.getAllNested(
        'programs',
        this.topic.id,
        {
          offset: offet,
          limit: limit,
        },
      )
      return tPrograms
    },
  },
}
